import { Form, Modal, Button, DatePicker, message } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";

const DownloadAllModal = (props) => {
  const { RangePicker, MonthPicker } = DatePicker;
  const {
    open,
    setVisible,
    onCreate,
    headermodaltitle,
    pickerType = "month",
  } = props;
  const [form] = Form.useForm();
  const [isActiveLoad, setIsActiveLoad] = useState("");
  const [monthRangeStart, setMonthRangeStart] = useState(null);

  const disabledDate = (current) => {
    if (pickerType === "range") {
      const startDate = moment("2023-11-01", "YYYY-MM-DD");
      const endDate = moment().subtract(1, "day");

      return (
        current &&
        (current < startDate.startOf("day") || current > endDate.endOf("day"))
      );
    }

    const startMonth = moment("2023-11", "YYYY-MM"); // Set your start month here
    const endMonth = moment(); // Current month
    return (
      current &&
      (current < startMonth.startOf("month") ||
        current > endMonth.endOf("month"))
    );
  };
  const disabledMonthRangeDate = (current) => {
    if (!current) return false;

    const startMonth = moment("2023-11", "YYYY-MM");
    const endMonth = moment();

    // Existing overall limits
    if (
      current.isBefore(startMonth, "month") ||
      current.isAfter(endMonth, "month")
    ) {
      return true;
    }

    // No first month selected yet
    if (!monthRangeStart) {
      return false;
    }

    // Allow maximum 3 months INCLUDING the selected starting month
    const minMonth = moment(monthRangeStart).subtract(2, "months");
    const maxMonth = moment(monthRangeStart).add(2, "months");

    return (
      current.isBefore(minMonth, "month") || current.isAfter(maxMonth, "month")
    );
  };
  useEffect(() => {
    if (secureLocalStorage.getItem("isActiveLoad") === "false") {
      setIsActiveLoad("");
    }
  }, [secureLocalStorage.getItem("isActiveLoad")]);

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        if (isMonthRange) {
          const [startMonth, endMonth] = values.month || [];

          if (startMonth && endMonth) {
            const monthDifference = endMonth.diff(startMonth, "months") + 1;

            if (monthDifference > 3) {
              message.error("Please select a maximum of 3 months.");
              return;
            }
          }
        }

        setIsActiveLoad("activeLoad");
        secureLocalStorage.setItem("isActiveLoad", "activeLoad");
        form.resetFields();
        setMonthRangeStart(null);
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const isDateRange = pickerType === "range";
  const isMonthRange = pickerType === "monthRange";
  return (
    <>
      <Modal
        className="all-modal downloadMdl"
        onCancel={handleCancel}
        onOk={handleCreate}
        title={<div className="headermodaltitle">{headermodaltitle}</div>}
        open={open}
        footer={[
          <div key="footer-actions" className="modalBtns">
            <Button
              key="back"
              className=" defaultBtn defaultGreyBtn"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              key="submit"
              className="defaultBtn"
              onClick={handleCreate}
              disabled={isActiveLoad === "activeLoad"}
              loading={isActiveLoad === "activeLoad"}
            >
              Export
            </Button>
          </div>,
        ]}
        width={"20vw"}
      >
        {isActiveLoad === "" ? (
          <Form form={form} layout="" className="pb-16">
            <Form.Item
              label=""
              name={isDateRange ? "dateRange" : "month"}
              rules={[
                {
                  required: true,
                  message: isDateRange
                    ? "Please select the date range!"
                    : isMonthRange
                      ? "Please select the month range!"
                      : "Please select the month!",
                },
              ]}
              labelAlign="left"
              className=""
            >
              {isDateRange ? (
                <RangePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  disabledDate={disabledDate}
                />
              ) : isMonthRange ? (
                <RangePicker
                  picker="month"
                  style={{ width: "100%" }}
                  format="MMMM YYYY"
                  disabledDate={disabledMonthRangeDate}
                  onCalendarChange={(dates) => {
                    setMonthRangeStart(dates?.[0] || null);
                  }}
                  onChange={(dates) => {
                    if (!dates) {
                      setMonthRangeStart(null);
                    }
                  }}
                />
              ) : (
                <MonthPicker
                  disabledDate={disabledDate}
                  placeholder="Select Month"
                  style={{ width: "100%" }}
                />
              )}
            </Form.Item>
          </Form>
        ) : (
          <div className="downloadAllLoader pb-16">
            <div>In-progress</div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default DownloadAllModal;
